import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import Panel from 'components/v2/Panel';
import ListItem from 'components/v2/list/ListItem';

export default function List({
  title,
  heading,
  className,
  children,
  testDataId,
}) {
  function renderHeading() {
    if (title) {
      return (
        <h3 className="mb-4" data-testid={`${testDataId || 'title'}`}>
          {title}
        </h3>
      );
    }
    if (heading) {
      return (
        <div className="mb-4" data-testid={`${testDataId || 'heading'}`}>
          {heading()}
        </div>
      );
    }
    return null;
  }
  return (
    <>
      {renderHeading()}
      <Panel className={classNames('divide-y divide-gray-200', className)}>
        {children}
      </Panel>
    </>
  );
}

List.propTypes = {
  title: PropTypes.string,
  heading: PropTypes.func,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.arrayOf([PropTypes.string, PropTypes.object]),
  ]),
};

List.Item = ListItem;
